export const NAVY = '#415A91';
export const INPUT_BG = '#F2F4F7';

export const inputStyles = {
  input: {
    backgroundColor: INPUT_BG,
    border: '1px solid #E4E7ED',
    borderRadius: 8,
    '&:focus': { borderColor: NAVY },
  },
  label: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: '#2A3140',
    marginBottom: 4,
  },
};
